<template>
  <el-dialog custom-class="production-order-dialog" :visible.sync="visible" width="min(1100px, calc(100vw - 24px))" :close-on-click-modal="false" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span>{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
            <el-button v-if="canReleaseOrder && isAuth('production:productionOrder:release')" type="primary" size="small" @click="releaseHandle">下达</el-button>
            <el-button v-if="canRefreshRouting && isAuth('production:productionOrder:refreshRouting')" type="primary" size="small" @click="refreshRoutingHandle">刷新工艺</el-button>
            <el-button v-if="canCompleteOrder && isAuth('production:productionOrder:finish')" type="primary" size="small" @click="completeHandle">完工</el-button>
            <el-button v-if="canExecOrderDoc && isAuth('production:productionIssue:save')" type="primary" size="small" @click="goIssue">领料</el-button>
            <el-button v-if="canExecOrderDoc && isAuth('production:productionReturn:save')" type="primary" size="small" @click="goReturn">退料</el-button>
            <el-button v-if="canExecOrderDoc && isAuth('production:productionSubcontract:save')" type="primary" size="small" @click="goSubcontract">委外</el-button>
            <el-button v-if="canExecOrderDoc && isAuth('production:productionReport:save')" type="primary" size="small" @click="goReport">报工</el-button>
            <el-button v-if="canExecOrderDoc && isAuth('production:productionReceipt:save')" type="primary" size="small" @click="goReceipt">入库</el-button>
            <el-button v-if="canSettleOrder && isAuth('production:productionSettle:save')" type="primary" size="small" @click="goSettle">结算</el-button>
            <el-button v-if="canCloseOrder && isAuth('production:productionOrder:close')" type="primary" size="small" @click="closeHandle">关闭</el-button>
            <el-button v-if="canEditOrder && isAuth('production:productionOrder:update')" type="primary" size="small" @click="editFromView">修改</el-button>
            <el-button v-if="canDeleteOrder && isAuth('production:productionOrder:delete')" type="primary" size="small" @click="deleteHandle">删除</el-button>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="100px">
      <el-row :gutter="12">
        <el-col :span="8" :xs="24" :sm="12">
          <el-form-item label="工单号" prop="productionOrderCode">
            <el-input v-model="dataForm.productionOrderCode" :disabled="formReadonly || !!dataForm.productionOrderId || codeReadonly"
              :placeholder="codeReadonly ? '保存时按单据规则生成' : '请输入工单号'" />
          </el-form-item>
        </el-col>
        <el-col :span="8" :xs="24" :sm="12">
          <el-form-item label="业务日期" prop="productionOrderDate">
            <el-date-picker v-model="dataForm.productionOrderDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formReadonly" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8" :xs="24" :sm="12" v-if="formReadonly && dataForm.settleStatus != null">
          <el-form-item label="结算状态">
            <el-tag :type="dataForm.settleStatus === '2' ? 'success' : (dataForm.pendingSettleId ? 'warning' : 'info')" size="small">
              {{ dataForm.settleStatus === '2' ? '已结算' : (dataForm.pendingSettleCode ? `未审（${dataForm.pendingSettleCode}）` : '未结算') }}
            </el-tag>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :span="8" :xs="24" :sm="12">
          <el-form-item label="计划开工">
            <el-date-picker v-model="dataForm.planStartDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formReadonly || isScheduleReadonly" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8" :xs="24" :sm="12">
          <el-form-item label="计划完工">
            <el-date-picker v-model="dataForm.planFinishDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formReadonly || isScheduleReadonly" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8" :xs="24" :sm="12">
          <el-form-item label="产品编码">
            <el-input v-model="dataForm.materialCode" readonly :disabled="formReadonly">
              <el-button v-if="!formReadonly && !hasSalesDemand" slot="append" @click="materialSelectorVisible = true">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :span="8" :xs="24" :sm="12"><el-form-item label="产品名称"><el-input v-model="dataForm.materialName" disabled /></el-form-item></el-col>
        <el-col :span="8" :xs="24" :sm="12">
          <el-form-item label="计划数量" prop="quantity">
            <el-input-number v-model="dataForm.quantity" :disabled="formReadonly || hasSalesDemand" :min="0.000001" :precision="2" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8" :xs="24" :sm="12">
          <el-form-item label="完工库位">
            <warehouse-location-select v-model="dataForm.wareHouseId" :disabled="formReadonly" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="canEditBomVersion" :gutter="12">
        <el-col :span="8" :xs="24" :sm="12">
          <el-form-item label="BOM版本">
            <el-select v-model="dataForm.bomVersion" clearable filterable placeholder="下达时取当前生效版" style="width:100%">
              <el-option v-for="v in bomVersionOptions" :key="v" :label="v" :value="v" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model="dataForm.remark" type="textarea" :disabled="formReadonly" />
      </el-form-item>

      <el-tabs v-model="activeTab">
        <el-tab-pane v-if="dataForm.demands && dataForm.demands.length" label="销售需求" name="demand">
          <el-table :data="dataForm.demands" border :header-cell-style="headStyle">
            <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
            <el-table-column prop="salesOrderCode" label="销售单号" min-width="120" header-align="center" align="left" />
            <el-table-column prop="customerName" label="客户" min-width="120" header-align="center" align="left" show-overflow-tooltip />
            <el-table-column prop="deliveryDate" label="交货日期" width="110" header-align="center" align="left">
              <template slot-scope="s">{{ formatDemandDate(s.row.deliveryDate) }}</template>
            </el-table-column>
            <el-table-column prop="orderQuantity" label="订购数量" width="100" header-align="center" align="left">
              <template slot-scope="s">{{ formatOrderQty(s.row.orderQuantity) }}</template>
            </el-table-column>
            <el-table-column prop="allocatedQty" label="分配数量" width="100" header-align="center" align="left" />
            <el-table-column prop="receivedQty" label="已入库" width="100" header-align="center" align="left" />
            <el-table-column label="待入库" width="100" header-align="center" align="left">
              <template slot-scope="s">{{ formatRemainReceipt(s.row) }}</template>
            </el-table-column>
            <el-table-column label="进度" width="80" header-align="center" align="left">
              <template slot-scope="s">{{ demandProgress(s.row) }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane v-if="dataForm.routingLines && dataForm.routingLines.length" label="工艺快照" name="routing">
          <el-table :data="dataForm.routingLines" border :header-cell-style="headStyle">
            <el-table-column prop="lineSort" label="序号" width="50" header-align="center" align="center" />
            <el-table-column prop="processCode" label="工序编码" header-align="center" align="left" />
            <el-table-column prop="processName" label="工序名称" header-align="center" align="left" />
            <el-table-column label="委外" width="60" header-align="center" align="left">
              <template slot-scope="s">{{ s.row.isOutProcess === '1' ? '是' : '否' }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane v-if="dataForm.bomLines && dataForm.bomLines.length" label="BOM快照" name="bom">
          <div v-if="bomSnapshotHint" style="margin-bottom:8px;font-size:13px;color:#606266">{{ bomSnapshotHint }}</div>
          <el-table :data="dataForm.bomLines" border :header-cell-style="headStyle">
            <el-table-column prop="lineSort" label="序号" width="50" header-align="center" align="center" />
            <el-table-column prop="childMaterialCode" label="物料编码" min-width="120" header-align="center" align="left" show-overflow-tooltip />
            <el-table-column prop="childMaterialName" label="物料名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
            <el-table-column prop="quantity" label="单位用量" width="100" header-align="center" align="left">
              <template slot-scope="s">{{ formatOrderQty(s.row.quantity) }}</template>
            </el-table-column>
            <el-table-column prop="lossRate" label="损耗%" width="80" header-align="center" align="left">
              <template slot-scope="s">{{ formatLossRate(s.row.lossRate) }}</template>
            </el-table-column>
            <el-table-column prop="requiredQty" label="需求数量" width="100" header-align="center" align="left">
              <template slot-scope="s">{{ formatOrderQty(s.row.requiredQty) }}</template>
            </el-table-column>
            <el-table-column prop="issuedQty" label="已领数量" width="100" header-align="center" align="left">
              <template slot-scope="s">{{ formatOrderQty(s.row.issuedQty) }}</template>
            </el-table-column>
            <el-table-column prop="returnedQty" label="已退数量" width="100" header-align="center" align="left">
              <template slot-scope="s">{{ formatOrderQty(s.row.returnedQty) }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane v-if="formReadonly && dataForm.productionOrderId && showCostTab" label="成本" name="cost">
          <el-descriptions v-if="costCard" :column="3" border size="small">
            <el-descriptions-item label="材料成本">{{ formatMoney(costCard.materialCost) }}</el-descriptions-item>
            <el-descriptions-item label="人工成本">{{ formatMoney(costCard.laborCost) }}</el-descriptions-item>
            <el-descriptions-item label="委外成本">{{ formatMoney(costCard.subcontractCost) }}</el-descriptions-item>
            <el-descriptions-item label="制造费用">{{ formatMoney(costCard.overheadCost) }}</el-descriptions-item>
            <el-descriptions-item label="合计">{{ formatMoney(costCard.totalCost) }}</el-descriptions-item>
            <el-descriptions-item label="入库数量">{{ formatOrderQty(costCard.receivedQty) }}</el-descriptions-item>
            <el-descriptions-item label="在制材料">{{ formatMoney(costCard.wipMaterialCost) }}</el-descriptions-item>
            <el-descriptions-item label="结转材料">{{ formatMoney(costCard.transferredMaterialCost) }}</el-descriptions-item>
            <el-descriptions-item label="单位成本">{{ formatMoney(costCard.avgUnitCost) }}</el-descriptions-item>
          </el-descriptions>
          <div v-else style="color:#909399">暂无成本数据</div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formReadonly" type="primary" :loading="submitting" @click="submit">确定</el-button>
    </span>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
  </el-dialog>
</template>

<script>
import {
  getProductionOrder,
  saveOrUpdateProductionOrder,
  deleteProductionOrder,
  releaseProductionOrder,
  completeProductionOrder,
  closeProductionOrder,
  refreshProductionOrderRouting,
  listMaterialBomVersion
} from '../../api/production/productionOrder'
import MaterialSelector from '../../components/MaterialSelector.vue'
import WarehouseLocationSelect from '../../components/WarehouseLocationSelect.vue'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' 00:00:00'
}

function blankForm() {
  return {
    productionOrderId: '',
    productionOrderCode: '',
    productionOrderDate: today(),
    planStartDate: '',
    planFinishDate: '',
    materialId: '',
    materialCode: '',
    materialName: '',
    quantity: 1,
    wareHouseId: '',
    bomVersion: '',
    orderStatus: '0',
    settleStatus: '0',
    sourceType: 'manual',
    mergeMode: 'na',
    remark: '',
    demands: [],
    bomLines: [],
    routingLines: []
  }
}

export default {
  name: 'ProductionOrderAddOrUpdate',
  components: { MaterialSelector, WarehouseLocationSelect },
  data() {
    return {
      visible: false,
      formReadonly: false,
      submitting: false,
      codeReadonly: false,
      materialSelectorVisible: false,
      activeTab: 'demand',
      bomVersionOptions: [],
      bomVersionRequestId: 0,
      costCard: null,
      permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      dataForm: blankForm(),
      dataRule: {
        productionOrderDate: [{ required: true, message: '业务日期不能为空', trigger: 'change' }],
        quantity: [{ required: true, message: '计划数量不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.formReadonly) return '生产工单详情'
      return this.dataForm.productionOrderId ? '修改生产工单' : '新增生产工单'
    },
    hasSalesDemand() {
      return this.dataForm.demands && this.dataForm.demands.length > 0
    },
    canEditBomVersion() {
      if (this.formReadonly) return false
      if (String(this.dataForm.orderStatus) !== '0') return false
      const hasPersistedBom = (this.dataForm.bomLines || []).some(row => row.orderBomId)
      return !hasPersistedBom
    },
    showCostTab() {
      const st = String(this.dataForm.orderStatus || '')
      return st === '1' || st === '3' || st === '4'
    },
    isScheduleReadonly() {
      const st = String(this.dataForm.orderStatus || '')
      return st === '1' || st === '3' || st === '4'
    },
    showViewToolbar() {
      return this.formReadonly && !!this.dataForm.productionOrderId
    },
    canReleaseOrder() { return String(this.dataForm.orderStatus) === '0' },
    canRefreshRouting() { return String(this.dataForm.orderStatus) === '1' },
    canCompleteOrder() { return String(this.dataForm.orderStatus) === '1' },
    canCloseOrder() {
      const st = String(this.dataForm.orderStatus)
      return (st === '1' || st === '3') && String(this.dataForm.settleStatus) === '2'
    },
    canExecOrderDoc() {
      const st = String(this.dataForm.orderStatus)
      return st === '1' || st === '3'
    },
    canSettleOrder() {
      return this.canExecOrderDoc && String(this.dataForm.settleStatus) !== '2' && !this.dataForm.pendingSettleId
    },
    canEditOrder() { return String(this.dataForm.orderStatus) === '0' },
    canDeleteOrder() { return String(this.dataForm.orderStatus) === '0' },
    bomSnapshotHint() {
      if (!this.dataForm.bomLines || !this.dataForm.bomLines.length) return ''
      const hasPersisted = this.dataForm.bomLines.some(row => row.orderBomId)
      if (hasPersisted && this.dataForm.bomVersion) {
        return `版本：${this.dataForm.bomVersion}（已冻结 BOM 快照，以下为需领料子件）`
      }
      if (String(this.dataForm.orderStatus) === '0') {
        const ver = this.dataForm.bomVersion ? `版本：${this.dataForm.bomVersion}，` : ''
        return `${ver}当前生效 BOM 预览（下达后冻结）；需求数量 = 计划数量 × 单位用量 × (1 + 损耗%)`
      }
      return '以下为需领料子件'
    }
  },
  watch: {
    activeTab(val) {
      if (val === 'cost') this.loadCostCard()
    }
  },
  created() { this.loadPerms() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'productionOrder' }).then(res => {
        if (!this.visible || this.dataForm.productionOrderId) return
        const rule = res.data || {}
        this.codeReadonly = !!rule.codeReadonly
        if (rule.previewCode) this.dataForm.productionOrderCode = rule.previewCode
      }).catch(() => {})
    },
    init(id, readonly) {
      this.visible = true
      this.formReadonly = !!readonly
      this.codeReadonly = false
      this.costCard = null
      this.$nextTick(() => {
        this.$refs.dataForm && this.$refs.dataForm.clearValidate()
        if (id) {
          getProductionOrder(id).then(res => {
            this.dataForm = Object.assign(blankForm(), res.data || {})
            if (!this.dataForm.demands) this.dataForm.demands = []
            if (!this.dataForm.bomLines) this.dataForm.bomLines = []
            if (!this.dataForm.routingLines) this.dataForm.routingLines = []
            this.activeTab = this.resolveDefaultTab()
            this.loadBomVersions()
            if (this.activeTab === 'cost') this.loadCostCard()
          }).catch(() => {})
        } else {
          this.dataForm = blankForm()
          this.activeTab = 'demand'
          this.bomVersionOptions = []
          this.resolveCode()
        }
      })
    },
    resolveDefaultTab() {
      if (this.dataForm.demands && this.dataForm.demands.length) return 'demand'
      if (this.dataForm.routingLines && this.dataForm.routingLines.length) return 'routing'
      if (this.dataForm.bomLines && this.dataForm.bomLines.length) return 'bom'
      return 'demand'
    },
    loadBomVersions() {
      const materialId = this.dataForm.materialId
      const requestId = ++this.bomVersionRequestId
      if (!materialId) {
        this.bomVersionOptions = []
        return
      }
      listMaterialBomVersion(materialId).then(res => {
        if (requestId !== this.bomVersionRequestId || this.dataForm.materialId !== materialId) return
        this.bomVersionOptions = res.data || []
      }).catch(() => {
        if (requestId === this.bomVersionRequestId && this.dataForm.materialId === materialId) this.bomVersionOptions = []
      })
    },
    loadCostCard() {
      if (!this.dataForm.productionOrderId) return
      request.get('/production/costCard', { params: { id: this.dataForm.productionOrderId } }).then(res => {
        this.costCard = res.data || {}
      }).catch(() => { this.costCard = null })
    },
    editFromView() {
      if (!this.canEditOrder) return
      this.formReadonly = false
    },
    reloadDetail() {
      if (!this.dataForm.productionOrderId) return Promise.resolve()
      return getProductionOrder(this.dataForm.productionOrderId).then(res => {
        this.dataForm = Object.assign(blankForm(), res.data || {})
        if (!this.dataForm.demands) this.dataForm.demands = []
        if (!this.dataForm.bomLines) this.dataForm.bomLines = []
        if (!this.dataForm.routingLines) this.dataForm.routingLines = []
        this.activeTab = this.resolveDefaultTab()
        this.loadBomVersions()
      })
    },
    runAction(fn, okMsg) {
      return fn().then(() => {
        this.$message.success(okMsg)
        this.$emit('refreshDataList')
        return this.reloadDetail()
      }).catch(() => {})
    },
    releaseHandle() {
      this.$confirm('下达时将取产品当前工艺并冻结 BOM/工艺快照，是否继续？', '提示', { type: 'warning' }).then(() => {
        this.runAction(() => releaseProductionOrder(this.dataForm.productionOrderId), '下达成功')
      }).catch(() => {})
    },
    refreshRoutingHandle() {
      this.$confirm('将按产品当前工艺重新生成工艺快照（须无领料/报工/委外）。BOM 快照不变。是否继续？', '提示', { type: 'warning' }).then(() => {
        this.runAction(() => refreshProductionOrderRouting(this.dataForm.productionOrderId), '工艺快照已刷新')
      }).catch(() => {})
    },
    completeHandle() {
      this.runAction(() => completeProductionOrder(this.dataForm.productionOrderId), '已标记完工')
    },
    closeHandle() {
      const msg = String(this.dataForm.settleStatus) === '2'
        ? '关闭后工单只读，是否继续？'
        : '关闭前须先完成生产结算。是否继续？'
      this.$confirm(msg, '提示', { type: 'warning' }).then(() => {
        this.runAction(() => closeProductionOrder(this.dataForm.productionOrderId), '已关闭')
      }).catch(() => {})
    },
    deleteHandle() {
      this.$confirm('确定删除该生产工单？', '提示', { type: 'warning' }).then(() => {
        deleteProductionOrder(this.dataForm.productionOrderId).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    go(path) {
      this.$router.push({
        path: '/production/' + path,
        query: {
          productionOrderId: this.dataForm.productionOrderId,
          productionOrderCode: this.dataForm.productionOrderCode,
          _prefill: String(Date.now())
        }
      })
    },
    goIssue() { this.go('productionIssue') },
    goReturn() { this.go('productionReturn') },
    goSubcontract() { this.go('productionSubcontract') },
    goReport() { this.go('productionReport') },
    goReceipt() { this.go('productionReceipt') },
    goSettle() { this.go('productionSettle') },
    onMaterialSelect(m) {
      if (!m) return
      if (this.dataForm.materialId !== m.materialId) {
        this.dataForm.bomVersion = ''
        this.bomVersionOptions = []
        this.dataForm.bomLines = []
        this.dataForm.routingLines = []
        this.activeTab = 'demand'
      }
      this.dataForm.materialId = m.materialId
      this.dataForm.materialCode = m.materialCode
      this.dataForm.materialName = m.materialName
      if (m.wareHouseId) this.dataForm.wareHouseId = m.wareHouseId
      this.loadBomVersions()
    },
    demandProgress(row) {
      const a = Number(row.allocatedQty || 0)
      const r = Number(row.receivedQty || 0)
      if (a <= 0) return '0%'
      return Math.min(100, Math.round(r / a * 100)) + '%'
    },
    formatRemainReceipt(row) {
      const remain = Number(row.allocatedQty || 0) - Number(row.receivedQty || 0)
      return remain > 0 ? remain.toFixed(2) : '0'
    },
    formatOrderQty(val) {
      if (val == null || val === '') return '—'
      const n = Number(val)
      if (Number.isNaN(n)) return '—'
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    formatDemandDate(val) {
      if (!val) return '—'
      return String(val).slice(0, 10)
    },
    formatLossRate(val) {
      if (val == null || val === '') return '—'
      const n = Number(val)
      if (Number.isNaN(n)) return '—'
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    formatMoney(val) {
      if (val == null || val === '') return '—'
      const n = Number(val)
      if (Number.isNaN(n)) return '—'
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    submit() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.dataForm.materialId) {
          this.$message.warning('请选择产品物料')
          return
        }
        if (this.dataForm.planStartDate && this.dataForm.planFinishDate && this.dataForm.planFinishDate < this.dataForm.planStartDate) {
          this.$message.warning('计划完工不能早于计划开工')
          return
        }
        this.submitting = true
        saveOrUpdateProductionOrder(this.dataForm).then(() => {
          this.submitting = false
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => { this.submitting = false })
      })
    }
  }
}
</script>

<style scoped>
.doc-dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-right: 32px;
}
.doc-dialog-actions {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.doc-dialog-actions .el-button {
  margin-left: 0;
}
</style>
<style>
.production-order-dialog {
  margin-top: 12px !important;
  max-height: calc(100vh - 24px);
  display: flex;
  flex-direction: column;
}
.production-order-dialog .el-dialog__body { min-height: 0; overflow-y: auto; overflow-x: hidden; }
.production-order-dialog .el-dialog__header, .production-order-dialog .el-dialog__footer { flex-shrink: 0; }
.production-order-dialog .el-dialog__header {
  height: auto;
  overflow: visible;
}
.production-order-dialog .el-dialog__title {
  display: block;
  width: 100%;
  line-height: normal;
}
</style>
